export default __webpack_public_path__ + "static/prueba-home-e00388962f0a52478218d38345686650.png";